import { render, staticRenderFns } from "./Team3.vue?vue&type=template&id=8d12ef8a&"
import script from "./Team3.vue?vue&type=script&lang=js&"
export * from "./Team3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports